'use client'
import {Link} from '@/libs/localeHandling/routing';
import IconRenderer from "@/libs/contentful/helper/IconRenderer";
import React, {useEffect, useState} from "react";
import {useTranslations} from "next-intl";

export default function ShareLinks() {
    const [isClient, setIsClient] = useState(false)

    useEffect(() => {
        setIsClient(true)
    }, [])

    const t = useTranslations('Defaults');

    if (!isClient || typeof window === "undefined") return;
    const shareLinks = [
        {
            name: 'E-Mail',
            link: 'mailto:?subject=Check%20this%20out&body=',
        },
        {
            name: 'facebook',
            link: 'https://www.facebook.com/sharer/sharer.php?u=',
        },
        {
            name: 'linkedin',
            link: 'https://www.linkedin.com/sharing/share-offsite/?url=',
        },
        {
            name: 'whatsApp',
            link: 'https://api.whatsapp.com/send?text=',
        },
    ]


    return (
        <ul className="list-none flex flex-row gap-m m-[0] justify-center flex-wrap">
            <li>
                <a onClick={() => navigator.clipboard?.writeText(window?.location.href)}
                      aria-label={t("copyToClipboard")}
                      className="group block rounded-full border-2 p-s focus-visible:outline-black focus-visible:bg-black hover:bg-black min-w-fit brand-transition cursor-pointer">
                    <IconRenderer icon="icon-share-link"
                                  className='brand-transition group-hover:fill-white group-focus-visible:fill-white'/>
                </a>
            </li>
            {shareLinks.map((link) => (
                <li key={link.name}>
                    <Link href={link.link + encodeURIComponent(window?.location.href)} target="_blank"
                          className="group block rounded-full border-2 p-s focus-visible:outline-black focus-visible:bg-black hover:bg-black min-w-fit brand-transition">
                        <IconRenderer icon={"icon-" + link.name}
                                      className='brand-transition group-hover:fill-white group-focus-visible:fill-white'/>
                    </Link>
                </li>
            ))}
        </ul>
    )
}